import styled from 'styled-components';

export const Content = styled.div`
  .buttonWrapper {
    display: flex;
    justify-content: end;
    grid-gap: 10px;
    padding: 20px 0 0;
  }

  .inputWrapper {
    display: flex;
    flex-direction: column;
    grid-gap: 20px;
    overflow-y: auto;
    max-height: 50vh;

    .select {
      height: 40px;
    }

    .add-more {
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 130%;
      color: var(--color-link);
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .note-text {
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 15.6px;
    color: var(--color-text-muted);
    margin-top: 15px;
    margin-bottom: 10px;
  }
`;
